import React from 'react';
import WayFadeUp from '../components/transitions/WayFadeUp';
import { PrismicImage } from '../components/common/prismicUtils';
import PrismicLink from '../components/PrismicLink';

const AwardsTable = ({ input, color }) => {
  const { items } = input;

  return (
    <WayFadeUp>
      <div
        id={input.id}
        className='w-100 pl4 pr4 pl5-l pr5-l center mt5 mb5 mt6-l mb6-l'
      >
        <h4
          className='f3 f2-l  tiempos lh-copy tc'
          style={{ color: `${color}` }}
        >
          {input.primary.title.text}
        </h4>

        <div className='flex flex-wrap justify-center'>
          {items.map((item) => {
            return (
              <PrismicLink
                key={item.award_title.text}
                className='w-20-l w-50 mt3 mb3 mt4-l mb4-l ph1'
                {...item.link}
              >
                <div className=' flex flex-column justify-between items-center tc'>
                  <div className='w3 h3 w3-m h3-m w3-l h3-l mb3'>
                    <PrismicImage
                      {...item.award_icon}
                      className='w-100 h-100'
                    />
                  </div>
                  <div>
                    {item.award_name?.text && (
                      <div className='f6 lh-copy b'>{item.award_name.text}</div>
                    )}
                    <div className='f6 lh-copy'>{item.award_title.text}</div>
                  </div>
                </div>
              </PrismicLink>
            );
          })}
        </div>
      </div>
    </WayFadeUp>
  );
};

export default AwardsTable;
